export const stateName = 'banners';